function n(a) {
  const e = a.regex;
  return { name: "Diff", aliases: ["patch"], contains: [{ className: "meta", relevance: 10, match: e.either(/^@@ +-\d+,\d+ +\+\d+,\d+ +@@/, /^\*\*\* +\d+,\d+ +\*\*\*\*$/, /^--- +\d+,\d+ +----$/) }, { className: "comment", variants: [{ begin: e.either(/Index: /, /^index/, /={3,}/, /^-{3}/, /^\*{3} /, /^\+{3}/, /^diff --git/), end: /$/ }, { match: /^\*{15}$/ }] }, { className: "addition", begin: /^\+/, end: /$/ }, { className: "deletion", begin: /^-/, end: /$/ }, { className: "addition", begin: /^!/, end: /$/ }] };
}
export {
  n as default
};
